<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="40%"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="名称" prop="name">
          <el-input
            v-model.trim="form.name"
            placeholder="请输入名称"
          />
        </el-form-item>
        <el-form-item label="key" prop="key">
          <el-input
            v-model.trim="form.key"
            placeholder="请输入key"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createOpenApiKey, updateOpenApiKey } from '@/api/settings'
export default {
  name: 'OpenApiKeyEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      form: {
        peopleId: '',
        key:'',
        name: '',
        order: 1,
      },
      rules: {
        name: [{ required: true, trigger: 'blur', message: '请输入名称' }],
        key: [{ required: true, trigger: 'blur', message: '请输入key' }],
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    async showEdit(row) {
      if (row) {
        this.title = '修改OpenApiKey'
        this.form = Object.assign(this.form, row.basic)
        this.form.peopleId = row.peopleId
        this.form.title = row.basic.name
        this.form.key = row.basic.openApiKey
      } else {
        this.title = '新增OpenApiKey'
      }
      this.dialogFormVisible = true
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const peopleId = this.form.peopleId
          //处理数据 图片数组转string
          const data = Object.assign({},this.form)
          this.$baseConfirm(
            `你确定要${peopleId ? '修改' : '新增'}OpenApiKey吗`,
            null,
            async () => {
              peopleId
                ? await updateOpenApiKey(data)
                : await createOpenApiKey(data)
              this.$baseMessage(
                `${peopleId ? '修改' : '新增'}OpenApiKey成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss">
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
</style>
